module.exports = __webpack_public_path__ + "img/erase.15861db2.svg";